module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/logo-122a604d5d8a8ed60705bc26ccdc5e7a.svg";